import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import Signin from '../popup/Signin';

import Utils from '../../utils/utils';
import i18n from '../../i18n';

const ProposeMyHome = () => {
    const navigate = useNavigate();
    const locale = i18n.language || 'en';

    const handleProposeHome = useCallback(() => {
        navigate(`/auth/${locale}/collection/signup`);
        window.location.reload();
    }, []);

    const handleAlreadyHome = useCallback(() => {
        document.dispatchEvent(new CustomEvent('open_signin_popup'));
    }, []);

    const logIn = <a onClick={handleAlreadyHome} />;

    return (
        <>
            <div className="propose-my-home-container">
                <div className="join-the-club-container">
                    <h1>{i18n.t('collection:join-the-club-title')}</h1>
                    <p>{i18n.t('collection:join-the-club-subtitle')}</p>
                </div>
                <div className="explaination-container">
                    <hr className="hidden-sm hidden-xs" />
                    <div className="explaination-step-container">
                        <div className="explaination-step-item">
                            <img
                                src={`${Utils.getAssetsDomain()}/images/website/collection/step0_home_info.svg`}
                                alt="home-info"
                            />
                            <div className="step-circle">
                                <span>1</span>
                            </div>
                            <p className="explaination-step-item-title">{i18n.t('collection:home-info')}</p>
                            <p>{i18n.t('collection:home-info-text')}</p>
                        </div>
                        <div className="explaination-step-item">
                            <img
                                src={`${Utils.getAssetsDomain()}/images/website/collection/step0_payment.svg`}
                                alt="payment"
                            />
                            <div className="step-circle">
                                <span>2</span>
                            </div>
                            <p className="explaination-step-item-title">{i18n.t('collection:payment')}</p>
                            <p>{i18n.t('collection:payment-text')}</p>
                        </div>
                        <div className="explaination-step-item">
                            <img
                                src={`${Utils.getAssetsDomain()}/images/website/collection/step0_invitation.svg`}
                                alt="invitation"
                            />
                            <div className="step-circle">
                                <span>3</span>
                            </div>
                            <p className="explaination-step-item-title">
                                {i18n.t('collection:receive-your-invitation')}
                            </p>
                            <p>{i18n.t('collection:receive-your-invitation-text')}</p>
                        </div>
                    </div>
                    <div className="explaination-button-container">
                        <button onClick={handleProposeHome} className="btn-propose-home btn-primary">
                            {i18n.t('collection:propose-my-home')}
                            <i className="icon icon-ChevronRight is-medium"></i>
                        </button>
                        <div className="already-member">
                            <Trans i18nKey="collection:already-member" components={[logIn]} i18n={i18n} />
                        </div>
                    </div>
                </div>
            </div>
            <Signin />
        </>
    );
};

export default ProposeMyHome;
